const basic: object = {
    type: "object",
    properties: {
      salutation: { type: "string", enum: ['Mr', 'Mrs', 'Ms', 'Dr'] },
      firstName: { type: "string", maxLength: 10 },
      lastName: { type: "string", readOnly: true },
      canContact: { type: "string", enum: [ "yes", "no" ], editor: "radioButtons", description: "Whether can contact" },
      preferredContact: { type: "array", items: {
          type: "string", enum: [ "phone", "email", "text" ]
        },
        editor: "multiCheck"
      },
      dateOfBirth: { type: "string", format: "date" },
      password: { type: "string", format: "password" },
      comments: { type: "string", editor: "textarea" },
      files: { type: "string", editor: "upload" },
      things: { type: "array", items: {
        type: "object", properties: {
          first: { type: "string" },
          second: { type: "string" }
        } }
      },
      address: { type: "object", properties: {
          addressLine: { type: "string" },
          postcode: { type: "string" }
        },
        required: [ "postcode" ]
      }
    },
    order: [ "salutation", [ "firstName", "lastName" ], "canContact", "preferredContact", "dateOfBirth", "password", "comments", "files", "things", "address" ],
    if: {
      type: "object", properties: {
        salutation: { type: "string", const: "Dr" }
      }
    },
    then: {
      type: "object", properties: {
        isMedical: { type: "boolean" }
      },
      order: [ "canContact", "isMedical" ]
    }
  };

const selector = {
    type: "object",
    properties: {
        selector: {
        type: "string",
        enum: [ "text", "checkbox", "nothing" ]
        }
    },
    anyOf: [
        {
        type: "object",
        properties: {
            selector: { type: "string", const: "text" },
            textInput: { type: "string" }
        }
        },{
        type: "object",
        properties: {
            selector: { type: "string", const: "checkbox" },
            checkboxInput: { type: "boolean" }
        }
        },{
        type: "object",
        properties: {
            selector: { type: "string", const: "nothing" }
        }
        }
    ]
};

const login = {
    "type": "object",
    "title": "Log In",
    "properties": {
        "email": {
            "type": "string",
            "format": "email"
        },
        "password": {
            "type": "string",
            "editor": "password"
        }
    },
    "required": [
        "email",
        "password"
    ],
    "$id": "http://schema-form.org/root"
}

const oneOf = {
    "type": "object",
    "$id": "http://schema-form.org/test",
    "definitions": {
      "item2": {
        "title": "Number",
        "type": "number",
        "className": "item2-class"
      }
    },
    "properties": {
      "things": {
        "type": "array",
        "items": {
          "type": [
            "string",
            "number"
          ],
          "oneOf": [
            {
              "title": "String",
              "type": "string"
            },
            {
              "title": "Number",
              "$ref": "#/definitions/item2"
            }
          ],
          "editor": "oneOfRadio"
        }
      }
    }
  };

const recursive = {
    "type": "object",
    "$id": "http://schema-form.org/test",
    "definitions": {
      "item2": {
        "type": "number",
        "className": "item2-class"
      },
      "test": {
        "type": "object",
        "properties": {
          "item1": {
            "type": "string",
            "const": "x"
          }
        },
        "required": [
          "item1"
        ]
      }
    },
    "properties": {
      "item1": {
        "type": "string"
      },
      "item2": {
        "$ref": "#/definitions/item2"
      }
    },
    "allOf": [
      {
        "if": {
          "$ref": "#/definitions/test"
        },
        "then": {
          "type": "object",
          "properties": {
            "item4": {
              "$ref": "http://schema-form.org/test"
            }
          }
        }
      }
    ]
  };

export const exampleSchemas: { [schema: string]: object} = {
    basic,
    selector,
    login,
    oneOf,
    recursive
};